import { ReactNode, useContext, useEffect, useState } from 'react';
import { createContext } from 'react';

import { PORTFOLIO_CONTRACTS, TOKENS } from '../../constants/reports/reports-filters';
import { PortfolioManagementContext } from '../portfolio-management/portfolio-management-provider';

interface IPositionsFiltersParamsProvider {
  children: ReactNode;
}

interface IPositionsFiltersProvider {
  filters: any;
}

export const PositionsFiltersContext = createContext<IPositionsFiltersProvider>(
  {} as IPositionsFiltersProvider,
);

export const PositionsFiltersProvider = ({ children }: IPositionsFiltersParamsProvider) => {
  const { POSITIONS } = PORTFOLIO_CONTRACTS;
  const [accountStates, setAccountStates] = useState<{ [key: string]: any }>({});
  const [positionsInstType, setPositionsInstType] = useState<any[]>(POSITIONS.CONTRACT_VALUES);
  const [token, setToken] = useState(TOKENS[0].label);
  const [tokenList, setTokenList] = useState(TOKENS);
  const [errorPosition, setErrorPosition] = useState(false);
  const [errorOrders, setErrorOrders] = useState(false);
  const { selectedAccountOption } = useContext(PortfolioManagementContext);

  useEffect(() => {
    if (selectedAccountOption) {
      const accountState = accountStates[selectedAccountOption.name];
      if (accountState) {
        setPositionsInstType(accountState.positionsInstType || POSITIONS.CONTRACT_VALUES);
        setToken(accountState.token || TOKENS[0].label);
        setTokenList(accountState.tokenList || TOKENS);
        setErrorPosition(accountState.errorPosition || false);
        setErrorOrders(accountState.errorOrders || false);
      } else {
        setPositionsInstType(POSITIONS.CONTRACT_VALUES);
        setToken(TOKENS[0].label);
        setTokenList(TOKENS);
        setErrorPosition(false);
        setErrorOrders(false);
      }
    }
  }, [selectedAccountOption]);

  useEffect(() => {
    if (!selectedAccountOption.name) return;
    if (selectedAccountOption) {
      setAccountStates((prevState) => ({
        ...prevState,
        [selectedAccountOption.name]: {
          token,
          tokenList,
          errorPosition,
          errorOrders,
        },
      }));
    }
  }, [selectedAccountOption, token, positionsInstType, tokenList, errorPosition, errorOrders]);

  const filters = {
    positionsInstType,
    setPositionsInstType,
    token,
    tokenList,
    errorPosition,
    errorOrders,
    setToken,
    setTokenList,
    setErrorPosition,
    setErrorOrders,
  };

  return (
    <PositionsFiltersContext.Provider
      value={{
        filters,
      }}
    >
      {children}
    </PositionsFiltersContext.Provider>
  );
};
